import {
  types,
  SnapshotIn,
  SnapshotOut,
  Instance,
  IAnyModelType,
  getRoot,
} from 'mobx-state-tree';
import { RootModelType } from '../Root';
import { modelWithCRUD } from '../utils/modelWithCRUD';

export const Warehouse = types.model('Warehouse', {
  id: types.union(types.identifier, types.identifierNumber),
  name: types.string,
});

export const WarehouseStore = modelWithCRUD('warehouses', Warehouse).named(
  'WarehouseStore'
);

export interface IWarehouse extends Instance<typeof Warehouse> {}
export interface IWarehouseSnapshotIn extends SnapshotIn<typeof Warehouse> {}
export interface IWarehouseSnapshotOut extends SnapshotOut<typeof Warehouse> {}

export const WarehouseReference = types.reference(
  types.late((): IAnyModelType => Warehouse),
  {
    get(identifier, parent): any {
      return (getRoot(parent!) as RootModelType).warehouseStore.getItemNaive(
        identifier
      );
    },
    set(value) {
      return value.id;
    },
  }
);
